import Vue from 'vue';
import Vuex from 'vuex';

import dialog from './dialog';
import global from './global';
import lang from './lang';
import form from './form';
import location from './location';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    lang,
    dialog,
    global,
    form,
    location
  },
});

store.VX_TYPES = {
  DIALOG: dialog.types,
  LANG: lang.types,
  GLOBAL: global.types,
  FORM: form.types,
  LOCATION: location.types
};

export default store;



// WEBPACK FOOTER //
// ./src/stores/index.js